// extracted by mini-css-extract-plugin
module.exports = {"teamsBtn":"styles_teamsBtn__318zL","userProfile":"styles_userProfile__3de5O"};